export const CREATE = 'CREATE';
export const NEEDSUPDATE = 'NEEDSUPDATE';
export const UPGRADE = 'UPGRADE';
export const INPROGRESS = 'INPROGRESS';
export const UPDATED = 'UPDATED';
export const NAME = 'Name';
export const GST = 'GST';
export const PAN = 'PAN';
export const CIN = "CIN";
export const GLOBAL_SEARCH_RESULT_BUY = 'GLOBAL_SEARCH_RESULT_BUY'
export const EXISTSINPROTFOLIO = 'existsInportfolio'
export const DOMESTIC = 'DOMESTIC';
export const INTERNATIONAL = 'INTERNATIONAL'
export const INDIA = 'India'
export const COMMON_WORDS = ["limited","private","enterprise","public","ltd","pvt","llp"]

export const EKYC = "EKYC";
export const VKYC = "VKYC";

export const MODAL_TYPE_SUCCESS = 'MODAL_TYPE_SUCCESS';
export const MODAL_TYPE_FAILURE = 'MODAL_TYPE_FAILURE';
export const MODAL_TYPE_FORM = 'MODAL_TYPE_FORM';
export const REGEX1 = /^[LU][0-9]{5}[A-Za-z]{2}[0-9]{4}[A-Za-z]{3}[0-9]{6}$/;
export const REGEX2 = /^A[A-Z]{2}-[0-9]{4}$/;
export const REGEX3 = /^F[0-9]{5}$/;

